<template>
  <div>
    <tab-title :tabList="tabList" url="personservice"></tab-title>
    <div class="router-section">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import TabTitle from '@/components/TabTitle'
export default {
  name: 'Patrol',
  components: { TabTitle },
  data () {
    return {
      tabList: [{
        label: '在岗人员',
        name: 'duty'
      }, {
        label: '劳务考勤',
        name: 'index'
      }]
    }
  },
  created () {
    // ...
  },
  methods: {
  }
}
</script>

<style scoped lang='scss'>
  .router-section {
    padding: 10px;
  }
</style>
